import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const NewsLettersSchema = Yup.object({
  newsLetterId: Yup.string(),
  title: Yup.string()
    .required(Validation.required.message.replaceAll("^", "Title"))
    .matches(Validation.plaintext.regex, Validation.plaintext.message),

  // description: Yup.string().required(Validation.required.message.replaceAll("^", "News description"))
  //   .matches(Validation.plaintext.regex, Validation.plaintext.message),

  link: Yup.string().matches(Validation.link.regex, Validation.link.message),

  image: Yup.string().required(Validation.required.message.replaceAll("^", "Image")),
  imageFile: Yup.mixed().nullable()
    //.required(Validation.required.message.replaceAll("^", "Image"))
    .test(
      "FILE_FORMAT",
      msgTypes.IMAGE_UNSUPPORTED_FORMAT,
      (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG,
      msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG, msgTypes.IMAGE_FORMAT.WEBP, msgTypes.IMAGE_FORMAT.WORD, msgTypes.IMAGE_FORMAT.PDF
      ].includes(value?.type))
    )
    .test(
      "FILE_SIZE",
      msgTypes.FILE_SIZE_MESSAGE_3MB,
      (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
    )
});
